import { LoadingOutlined } from '@ant-design/icons';
import React from 'react';

const LoadingPage = () => {
    return (
        <>
            <div className="loading__root">
                <div className="loading__center">
                    <LoadingOutlined spin={true} className="loading__icon" />
                </div>
            </div>
        </>
    );
};

export default LoadingPage;
